

import React from 'react'
import { Container, Row, Col } from 'reactstrap'

import CommonSection from '../components/ui/CommonSection/CommonSection'
import NftCard from '../components/ui/NftCard/NftCard'
import img from '../assets/images/img-01.jpg'
import avatar from '../assets/images/ava-01.png'

import '../styles/create.css'


const item = {
  id: "04",
  title: "Guard",
  desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia, nostrum et deleniti vero corrupti facilis minima laborum nesciunt nulla error natus saepe illum quasi ratione suscipit tempore dolores. Recusandae, similique modi voluptates dolore repellat eum earum sint.",
  imgUrl: img,
  creator: "Zakir Hossain",
  creatorImg: avatar,
  currentBid: 7.89,
}

const Create = () => {
  return (
   <>
    <CommonSection  title='Create Item' />


    <section>
    <Container>
    <Row>
      <Col lg='3' md='4' sm='6'>
        <h2 className='mb-4 text-light'> Preview Item</h2>
        <NftCard item={item} />
      </Col>

      <Col lg='9' md='8' sm='6'>
        <div className='create_item'>
          <form>
            <div className='form_input'>
              <label htmlFor="">Upload File</label>
              <input type='file' className='upload_input' />
            </div>


            <div className='form_input'>
              <label htmlFor="">Price</label>
              <input type='number' placeholder='Enter price for one item(ETH)' />
            </div>

            <div className='form_input'>
              <label htmlFor="">Minimum Bid</label>
              <input type='number' placeholder='Enter minimum bid' />
            </div>

            <div className='d-flex align-items-center justify-content-between'>

            
            <div className='form_input w-50'>
              <label htmlFor="">Starting Date</label>
              <input type='date' />
            </div>


            <div className='form_input w-50'>
              <label htmlFor="">Expiration Date</label>
              <input type='date'  />
            </div>

              
            </div>

            <div className='form_input'>
              <label htmlFor="">Title</label>
              <input type='text' placeholder='Enter a Title'  />
            </div>

            <div className='form_input'>
              <label htmlFor="">Description</label>
              <textarea
              name=''
              id=''
              rows="7"
              placeholder='Enter a Title'
              className='w-100'
              >

              </textarea>
            </div>










          </form>
        </div>
      </Col>
    </Row>
      
    </Container>
   </section>
   </>

   
  )
}

export default Create